import { ClbBreadcrumb } from "@celebration/react";
import { Button } from "@components/index";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import "./Breadcrumb.component.scss";

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const pathnames = location.pathname
    .split("/")
    .filter(Boolean)
    .filter((path) => Number.isNaN(Number(path)));

  return (
    <>
      <div className="breadcrumb-wrapper">
        <Button
          buttonStyle="primary"
          icon="arrow-left"
          onClick={() => void navigate(-1)}
        />

        <ClbBreadcrumb
          items={pathnames.reduce(
            (previous, path) => {
              const currentUrl = `${previous[previous.length - 1]?.url}/${path}`;

              previous.push({
                id: previous.length,
                url: currentUrl.replace(/\/+/g, "/"),
                label: t(`breadcrumb.${path}`),
              });

              return previous;
            },
            [
              {
                id: 0,
                url: "/",
                label: "Home",
              },
            ]
          )}
        />
      </div>
      <Outlet />
    </>
  );
};

export default Breadcrumb;
